/**
 * Sentry configuration — local development (no DSN; Sentry disabled).
 */

const environment = 'development';

const dsn = 'NONE_FOR_DEVELOPMENT';

export default {
  environment,
  dsn,
};

export { environment, dsn };
